import { createStore } from 'vuex'

import modules from './modules'
import authModule from './modules/auth'
import createPersistedState from "vuex-persistedstate";
const store = createStore({
  modules: {
    ...modules,
    auth: authModule,
  },
    plugins: [createPersistedState()],
  strict: process.env.NODE_ENV !== 'production',
})

export default store

